import { CookieConsentBanner } from './CookieConsent'
import { useConsentedTrackers } from './trackers'

/**
 * The one thing this module hands the shell: ask, and obey.
 *
 * The two halves are separate files because they do opposite jobs, and they are mounted together because
 * neither works alone - a banner that collects a decision nothing acts on, or trackers that load without
 * one having been offered. Obeying does not depend on asking: the hook runs before the banner's early
 * return, so a customer who decided in a previous session still gets what they permitted.
 *
 * Obeying includes taking back (§9.738): a decision that refuses what the page runs reloads it, and `reload` is a
 * prop only so a test can watch that happen. The shell mounts this with no props, so the page really reloads.
 */
export function ConsentSurface({ reload }: { reload?: () => void }) {
  useConsentedTrackers({ reload })
  return <CookieConsentBanner />
}
